import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { Request } from './request.model';
import { map } from 'rxjs/operators';

@Injectable()
export class RequestService {
  private mockRequest: Request = new Request();
  private requestSubject = new BehaviorSubject<Request>(null);
  request$: Observable<Request>;

  constructor() {
    this.mockRequest.location = {
      'streetAddress': '6416 Peters Lane',
      'city': 'Valatie',
      'state': 'NY',
      'zip': '12184'
    };
    this.mockRequest.loan = {
      'closingDate': new Date('1/1/1900'),
      'loanAmount': 1000,
      'purchasePrice': 1000,
      'loanType': 'Loan Type',
      'mortgageType': 'Mortgage Type',
      'rateType': 'Rate Type'
    };
    this.request$ = this.requestSubject.pipe(
      map((request: Request) => request)
    );
  }

  pushRequest(request: Request): void {
    this.requestSubject.next(request);
  }
}
